import request from '@/utils/request';

// 选择用户列表
export function userRangList(data) {
    return request({
        url: '/jd-car-user/user/userRangListNew',
        method: 'post',
        data: data
    })
}

// 选择部门列表
export function dptRangList(data) {
    return request({
        url: '/jd-car-user/user/dptRangListNew',
        method: 'post',
        data: data
    })
}

// 选择车辆列表
export function queryCarList(data) {
    return request({
        url: '/share-car-car/car/queryCarList',
        method: 'post',
        data: data
    })
}

// 选择充电桩列表
export function queryCarChargeList(data) {
    return request({
        url: '/share-car-manager/charge/queryCarChareList',
        method: 'post',
        data: data
    })
}
